
  (function () {
    var isGrabDiscount = false;

    document.addEventListener('click', function (e) {
      try {
        if (
          e &&
          e.target &&
          typeof e.target.closest === 'function' &&
          (e.target.closest('.tl-manual-add-to-cart-btn') ||
           e.target.closest('[onclick*="handleManualAddToCart"]'))
        ) {
          isGrabDiscount = true;
        }
      } catch (err) {
        console.warn('[Salepify Custom] Error detecting grab click:', err);
      }
    }, true);

    window.addEventListener('TLDISCOUNTS:add', function () {
      try {
        if (!isGrabDiscount) return;
        isGrabDiscount = false;

        try {
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:refresh', { bubbles: true })
          );
        } catch (eventErr) {
          console.warn('[Salepify Custom] Error dispatching cart:refresh:', eventErr);
        }

        setTimeout(function () {
          try {
            var cartDrawer = document.getElementById('cart-drawer');
            if (cartDrawer && typeof cartDrawer.show === 'function') {
              cartDrawer.show();
            }
          } catch (drawerErr) {
            console.warn('[Salepify Custom] Error showing cart drawer:', drawerErr);
          }
        }, 200);
      } catch (err) {
        console.warn('[Salepify Custom] Error in TLDISCOUNTS:add handler:', err);
      }
    });
  })();
